"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapButtons = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const clockIcon_svg_1 = __importDefault(require("../../../assets/icons/clockIcon.svg"));
const copyLinkIcon_svg_1 = __importDefault(require("../../../assets/icons/copyLinkIcon.svg"));
const filterIcon_svg_1 = __importDefault(require("../../../assets/icons/filterIcon.svg"));
const booleans_1 = require("../../../const/booleans");
const fixedSessionsSelectors_1 = require("../../../store/fixedSessionsSelectors");
const hooks_1 = require("../../../store/hooks");
const sessionFiltersSlice_1 = require("../../../store/sessionFiltersSlice");
const timelapseSlice_1 = require("../../../store/timelapseSlice");
const filters_1 = require("../../../types/filters");
const userStates_1 = require("../../../types/userStates");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const CopyLinkComponent_1 = require("../../molecules/Popups/CopyLinkComponent");
const DesktopSessionFilters_1 = require("../../molecules/SessionFilters/DesktopSessionFilters");
const MapButton_1 = require("./MapButton");
const S = __importStar(require("./MapButtons.style"));
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["FILTER"] = "filter";
    ButtonTypes["TIMELAPSE"] = "timelapse";
    ButtonTypes["COPY_LINK"] = "copyLink";
    ButtonTypes["SHARE"] = "share";
})(ButtonTypes || (ButtonTypes = {}));
const MapButtons = () => {
    const { goToUserSettings, currentUserSettings, sessionType, isIndoor } = (0, mapParamsHandler_1.useMapParams)();
    const [activeButtons, setActiveButtons] = (0, react_1.useState)([
        ButtonTypes.FILTER,
    ]);
    const [activeCopyLinkButton, setActiveCopyLinkButton] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const fixedSessionsType = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectFixedSessionsType);
    const listSessions = (0, hooks_1.useAppSelector)((state) => (0, fixedSessionsSelectors_1.selectFixedSessionsList)(state, fixedSessionsType));
    const isDormant = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectIsDormantSessionsType);
    const showFilters = activeButtons.includes(ButtonTypes.FILTER);
    const isModalView = currentUserSettings === userStates_1.UserSettings.ModalView;
    const isTimelapseButtonVisible = !isModalView && sessionType === filters_1.SessionTypes.FIXED;
    const isTimelapseDisabled = listSessions.length === 0 || isDormant || isIndoor === booleans_1.TRUE;
    const isTimelapseButtonActive = activeButtons.includes(ButtonTypes.TIMELAPSE) &&
        currentUserSettings === userStates_1.UserSettings.TimelapseView;
    const filtersButtonClosed = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectFiltersButtonClosed);
    const handleCopyLinkClick = () => {
        setActiveCopyLinkButton(true);
    };
    const handleTimelapseClick = () => {
        if (activeButtons.includes(ButtonTypes.TIMELAPSE)) {
            setActiveButtons([]);
            goToUserSettings(userStates_1.UserSettings.MapView);
            dispatch((0, timelapseSlice_1.resetTimelapseData)());
        }
        else {
            setActiveButtons([ButtonTypes.TIMELAPSE]);
            goToUserSettings(userStates_1.UserSettings.TimelapseView);
        }
        setActiveCopyLinkButton(false);
    };
    const handleFilterClick = () => {
        if (activeButtons.includes(ButtonTypes.FILTER)) {
            setActiveButtons([]);
            dispatch((0, sessionFiltersSlice_1.setFiltersButtonClosed)(true));
        }
        else {
            setActiveButtons([ButtonTypes.FILTER]);
            dispatch((0, sessionFiltersSlice_1.setFiltersButtonClosed)(false));
            if (currentUserSettings === userStates_1.UserSettings.CrowdMapView) {
                goToUserSettings(userStates_1.UserSettings.CrowdMapView);
            }
            if (currentUserSettings === userStates_1.UserSettings.TimelapseView) {
                goToUserSettings(userStates_1.UserSettings.MapView);
                dispatch((0, timelapseSlice_1.resetTimelapseData)());
            }
        }
        setActiveCopyLinkButton(false);
    };
    (0, react_1.useEffect)(() => {
        if (currentUserSettings === userStates_1.UserSettings.TimelapseView) {
            setActiveButtons([ButtonTypes.TIMELAPSE]);
        }
        else {
            filtersButtonClosed
                ? setActiveButtons([])
                : setActiveButtons([ButtonTypes.FILTER]);
        }
    }, [currentUserSettings, filtersButtonClosed]);
    return (react_1.default.createElement(S.MapButtonsWrapper, null,
        react_1.default.createElement(S.MapButtons, null,
            react_1.default.createElement(MapButton_1.MapButton, { title: t("navbar.filter"), image: filterIcon_svg_1.default, onClick: handleFilterClick, alt: t("navbar.altFilter"), isActive: activeButtons.includes(ButtonTypes.FILTER), className: "active-overlay" }),
            isTimelapseButtonVisible && (react_1.default.createElement(MapButton_1.MapButton, { title: t("navbar.timelapse"), image: clockIcon_svg_1.default, onClick: handleTimelapseClick, alt: t("navbar.altTimelapse"), isActive: isTimelapseButtonActive, isDisabled: isTimelapseDisabled, className: "active-overlay" })),
            react_1.default.createElement(CopyLinkComponent_1.CopyLinkComponent, { button: react_1.default.createElement(MapButton_1.MapButton, { title: t("navbar.copyLink"), image: copyLinkIcon_svg_1.default, onClick: handleCopyLinkClick, alt: t("navbar.altCopyLink"), isActive: activeCopyLinkButton, className: "active-overlay" }), isIconOnly: false, showBelowButton: true, onOpen: handleCopyLinkClick, onClose: () => {
                    setActiveCopyLinkButton(false);
                } })),
        showFilters && react_1.default.createElement(DesktopSessionFilters_1.DesktopSessionFilters, null)));
};
exports.MapButtons = MapButtons;
